import { render, staticRenderFns } from "./Published-figure.vue?vue&type=template&id=3eb4d35e&scoped=true"
import script from "./Published-figure.vue?vue&type=script&lang=js"
export * from "./Published-figure.vue?vue&type=script&lang=js"
import style0 from "./Published-figure.vue?vue&type=style&index=0&id=3eb4d35e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb4d35e",
  null
  
)

export default component.exports